export const SHELLY = 'shelly'
export const SATEC = 'satec'

export const WATER = 'water'
export const ELECTRICITY = 'electricity'
export const GAS = 'gas'

export const METER_TYPE = [SHELLY, SATEC]
export const METER_CATEGORY = [WATER, ELECTRICITY, GAS]
